const fromdata = [
	{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		width: "210px",
		lablewith: "100px",
		btx: true,
		options: [],
		event: 'invClassChange'
	},
	{
		inputdata: "",
		title: "产品",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入检索",
		types: "",
		inputtype: "selectautocomplete", 
		width: "210px",
		lablewith: "100px",
		btx: true,
		options: [],
		event: 'invNameChange',
        pt: true
	},
	{
		inputdata: "",
		title: "医院",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入检索",
		types: "",
		inputtype: "selectautocompleteHosType",
		width: "210px",
		lablewith: "100px",
		btx: true,
		options: [],
		event: 'hospitalChange'
	},
	{
		inputdata: "",
		title: "付款方",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入检索",
		types: "",
		inputtype: "selectautocompletes",
		width: "210px",
		lablewith: "100px",
		btx: true,
		options: [],
		event: 'buyerChange'
	},
	{
		inputdata: "",
		title: "开票日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "dates",
		width: "210px",
		lablewith: "100px",
		btx: true
	}
];
export default fromdata;